import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Form, Input, Checkbox } from 'semantic-ui-react'

const propTypes = {
};

const defaultProps = {
};

class ChangePWD extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pwd: null,
      rePwd: null
    };
  }

  componentWillReceiveProps() {
    this.setState({
      pwd: null,
      rePwd: null
    });
  }

  handlePwdEvent = (e, data) => {
    this.setState({
      pwd: data.value
    });
  }

  handleRePwdEvent = (e, data) => {
    this.setState({
      rePwd: data.value
    });
  }

  render() {
    const { open, size, closeFn, okFn } = this.props;
    const { pwd, rePwd } = this.state;

    return (
      <Modal className="change-pwd-mod" size={size} open={open} onClose={(e) => closeFn(false, "small")}>
        <Modal.Header>
          비밀번호 초기화
        </Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field inline>
              <label>초기화 비밀번호</label>
              <Input type="password" placeholder="비밀번호" min="1" max="20" onChange={this.handlePwdEvent}/>
            </Form.Field>
            <Form.Field inline>
              <label>초기화 비밀번호 재입력</label>
              <Input type="password" placeholder="비밀번호 재입력" min ="1" max="20" onChange={this.handleRePwdEvent}/>
            </Form.Field>
            <Form.Field inline>
              <label className="text-label">비밀번호 초기화 후, 사용자가 최초 로그인시, 반드시 비밀번호 재설정 과정을 거치게 됩니다.</label>
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            className="cancel"
            inverted
            color="grey"
            onClick={(e) => closeFn(false, '')}>
            취소
          </Button>
          <Button
            className="ok"
            color="green"
            onClick={(e) => okFn(pwd, rePwd)}
            content="완료" />
        </Modal.Actions>
      </Modal>
    );
  }
}

ChangePWD.propTypes = propTypes;
ChangePWD.defaultProps = defaultProps;

export default ChangePWD;
